import { render } from "./ComparasionPrice.vue?vue&type=template&id=8c38caa6&scoped=true"
import script from "./ComparasionPrice.vue?vue&type=script&lang=js"
export * from "./ComparasionPrice.vue?vue&type=script&lang=js"

import "./ComparasionPrice.vue?vue&type=style&index=0&id=8c38caa6&scoped=true&lang=css"
import "./ComparasionPrice.vue?vue&type=style&index=1&id=8c38caa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c38caa6"]])

export default __exports__